import styled from 'styled-components';

export const ListElementWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 15px;
  &:first-child {
    margin-top: 0;
  }
`;

export const RemoveIcon = styled.div`
  cursor: pointer;
  margin-left: 15px;
`;
